<template>
    <v-card
            class="mx-auto mt-4 pb-12"
            max-width="600"
            min-width="400"
    >
        <v-card-title>
            <v-list-item-content>
                <v-list-item-title>Employee Id Print Out</v-list-item-title>
            </v-list-item-content>
            <v-row
                    align="center"
                    justify="end"
            >
                <v-btn class="mr-2" color="primary" small @click="printContent(strId)">
                    <v-icon
                            left
                    >
                        mdi-printer-check
                    </v-icon>
                    Print ID Card
                </v-btn>
            </v-row>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-card-text>
            <div :id="strId">
                <table
                        style="background-position:top center; display: block; background-repeat:repeat-x; background-color:White; width: 450px; margin: 0px auto 0px auto; border: 0px solid Silver;
            -ms-filter: progid:DXImageTransform.Microsoft.Shadow(Strength=2, Direction=135, Color='white'); filter: progid:DXImageTransform.Microsoft.Shadow(Strength=2, Direction=135, Color='white');
             color: black; font-weight: 700; border-spacing: 0px;">
                    <tr>
                        <td>
                            <div id="divprint">
                                <table :style="backgroundImageInlineStyleFront" border="0" cellpadding="0"
                                       cellspacing="0" width="450px">
                                    <tr>
                                        <td>
                                            <table border="0" cellpadding="0" cellspacing="0" style="height: 130px"
                                                   width="450px">
                                                <!--                        <tr>-->
                                                <!--                          <td align="center" colspan="4" style="height:10px"></td>-->
                                                <!--                        </tr>-->
                                                <tr>
                                                    <td align="center" colspan="2"></td>
                                                    <td align="right" colspan="2">
                                                        <img :src="photoUrl" alt="profile picture" height="120px"
                                                             width="120px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </td>
                                                </tr>
                                            </table>
                                            <table border="0" cellpadding="0" cellspacing="0" style="height: 90px"
                                                   width="450px">
                                                <tr>
                                                    <td colspan="4" style="height:10px" valign="middle"></td>
                                                </tr>
                                                <tr>
                                                    <td align="center" style="width:10px"></td>
                                                    <td :style="{width: nameWidth + '%'}" align="center" colspan="2"
                                                        valign="top">
                                                        <label style="font-weight: bold"
                                                               v-text="alternativeFullName"></label>
                                                    </td>
                                                    <td align="center" style="width:20px"></td>
                                                    <td align="center" colspan="2" valign="top">
                                                        <label style="font-weight: bold"
                                                               v-text="alternativeJobTitle"></label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td align="center" style="width:10px"></td>
                                                    <td align="center" colspan="2" valign="top">
                                                        <label style="font-weight: bold" v-text="fullName"></label>
                                                    </td>
                                                    <td align="center" style="width:20px"></td>
                                                    <td align="center" colspan="2" valign="top">
                                                        <label style="font-weight: bold" v-text="jobTitle"></label>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table border="0" cellpadding="0" cellspacing="0"
                                                   style="height: 50px; font-size: small" width="450px">
                                                <tr>
                                                    <td colspan="4" style="height: 13px" valign="middle">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td align="left" colspan="2" style="padding-left: 4px">
                                                        <label style=" font-size: small; font-weight: bold">የመታወቂያ ቁ./ID
                                                            No.:</label>
                                                        <label style="font-weight: bold; font-size: small;"
                                                               v-text="employeeNo"></label>
                                                    </td>
                                                    <td align="right" colspan="2"
                                                        style="padding-right: 16px;margin: 0px">
                                                        <label style="font-weight: bold">Phone:</label>
                                                        <label style="font-weight: bold"
                                                               v-text="employeePhoneNo"></label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td align="left" colspan="4" style="padding-left: 4px">
                                                        <label style="font-weight: bold" v-text="tel"></label> &nbsp;&nbsp;
                                                        <label style="font-weight: bold" v-text="pOBox"></label> &nbsp;&nbsp;
                                                        <label style="font-weight: bold" v-text="address"></label>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                                <!--                <table border="0" style="height: 5px;" width="450px">-->
                                <!--                  <tr>-->
                                <!--                    <td>-->
                                <!--                    </td>-->
                                <!--                  </tr>-->
                                <!--                </table>-->
                                <table :style="backgroundImageInlineStyleBack" border="0" cellpadding="0"
                                       cellspacing="0"
                                       width="450px">
                                    <tr>
                                        <td>
                                            <table border="0" cellpadding="0" cellspacing="0" height="40px;"
                                                   style="font-size: small" width="450px">
                                                <tr>
                                                    <td colspan="8" style="height:10px">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8" style="padding-left: 4px">
                                                        <label style="font-weight: bold">የመኖሪያ አድራሻ/Residence
                                                            address:</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8" style="height: 0px;">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        &nbsp;
                                                    </td>
                                                    <td style="width:60px" valign="bottom">
                                                        <label style="font-weight: bold">ክ/ከተማ:</label>
                                                    </td>
                                                    <td rowspan="2" style="width:120px" valign="middle">
                                                        <label style="font-weight: bold" v-text="subCity"></label>
                                                    </td>
                                                    <td style="width:50px" valign="bottom">
                                                        <label style="font-weight: bold">ቀበሌ:</label>
                                                    </td>
                                                    <td rowspan="2" style="width:50px" valign="middle">
                                                        <label style="font-weight: bold" v-text="kebele"></label>
                                                    </td>
                                                    <td style="width:70px" valign="bottom">
                                                        <label style="font-weight: bold">የቤት ቁ.:</label>
                                                    </td>
                                                    <td rowspan="2" style="width:50px" valign="middle">
                                                        <label style="font-weight: bold" v-text="houseNumber"></label>
                                                    </td>
                                                    <td valign="bottom">
                                                        &nbsp;&nbsp;
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">
                                                        &nbsp;&nbsp;
                                                    </td>
                                                    <td valign="top">
                                                        <label style="font-weight: bold">SubCity:</label>
                                                    </td>
                                                    <td valign="top">
                                                        <label style="font-weight: bold">Kebele</label>
                                                    </td>
                                                    <td valign="top">
                                                        <label style="font-weight: bold">House No</label>
                                                    </td>
                                                </tr>
                                            </table>

                                            <table border="0" cellpadding="0" cellspacing="0" style="height:210px"
                                                   width="450px">
                                                <tr align="left">
                                                    <td colspan="8">
                                                        <div  style ="text-align:center;">
                                                        <label style="font-weight: bold; "
                                                               v-text="iDDescriptionAmharic"></label><br/>
                                                        <label style="font-weight: bold;"
                                                               v-text="iDDescription"></label> <br />
                                                        </div>
                                                         <label style="font-weight: bold">Emergency Contact:</label>
                                                        <label style="font-weight: bold"
                                                               v-text="emergencyContactName"></label>
                                                        <label v-if="emergencyContactPhone"
                                                               style="font-weight: bold">/</label>
                                                        <label style="font-weight: bold"
                                                               v-text="emergencyContactPhone"></label>
                                                    </td>

<!--                                                    <td colspan="4" style="padding-left: 4px" valign="top">-->
<!--                                                        <label style="font-weight: bold">Emergency Contact:</label>-->
<!--                                                    </td>-->
                                                </tr>


<!--                                                <tr>-->
<!--                                                    <td colspan="4" style="padding-left: 4px" valign="top">-->
<!--                                                        <label style="font-weight: bold">Emergency Contact:</label>-->
<!--                                                    </td>-->
<!--                                                    <td colspan="4" valign="top">-->
<!--                                                        <label style="font-weight: bold"-->
<!--                                                               v-text="emergencyContactName"></label>-->
<!--                                                        <label v-if="emergencyContactPhone"-->
<!--                                                               style="font-weight: bold">/</label>-->
<!--                                                        <label style="font-weight: bold"-->
<!--                                                               v-text="emergencyContactPhone"></label>-->
<!--                                                    </td>-->
<!--                                                </tr>-->


                                                <tr>
                                                    <td colspan="4" style="padding-left: 4px" valign="top">
                                                        <label style="font-weight: bold">የኃላፊ ፊርማ</label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td align="left" style="width:10px;"></td>
                                                    <td align="left" colspan="2" valign="bottom">
                                                      <label style="font-weight: bold" v-text="issuedDate"></label><br/>
                                                      <label style="font-weight: bold" >የሚያበቃበት: {{endDate}}</label>
                                                    </td>
                                                    <td align="center" style="width:20px"></td>
                                                    <td align="center" colspan="2" valign="bottom">
                                                        <barcode display-value="false" height="15"
                                                                 margin-bottom="0" margin-top="0px"
                                                                 text-margin="0"
                                                                 v-bind:value="employeeNo">
                                                        </barcode>
                                                    </td>
                                                </tr>

                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";

export default {
    components: {
        'barcode': VueBarcode
    },
    data() {
        return {
            loadingId: false,
            strId: 'contentToPrint',
            photoUrl: '',
            nameWidth: '',
            alternativeFullName: '',
            alternativeJobTitle: '',
            fullName: "",
            jobTitle: '',
            employeeNo: '',
            employeePhoneNo: '',
            tel: "",
            pOBox: '',
            address: '',
            subCity: '',
            alternativeSubCity: '',
            kebele: '',
            houseNumber: '',
            issuedDate: `የተሰጠበት: ${new Date().toLocaleDateString('en-GB')}`,
            endDate:"",
            emergencyContactName: "",
            emergencyContactPhone: "",
            dutyStation: '',
            idFrontImage: '',
            idBackImage: '',
            iDDescription: '',
            iDDescriptionAmharic: ''
        }
    },

    created() {
        this.loadingId = true;
        const {id} = this.$route.params
        axios({
            url: `/fhir/employeeId/${id}`,
            method: "GET",
        })
            .then(async ({data}) => {
                this.fullName = data.fullName
                this.alternativeFullName = data.alternativeFullName
                this.employeeNo = data.employeeId
                this.employeePhoneNo = data.phone
                if (data?.photo) {
                    this.photoUrl = "data:" +
                        data.photo[0].contentType +
                        ";base64," +
                        data.photo[0].data
                }
                this.subCity = data.subCity
                this.kebele = data.kebele
                this.houseNumber = data.houseNumber
                this.jobTitle = data.jobTitle
                this.alternativeJobTitle = data.alternativeJobTitle
                this.dutyStation = data.dutyStation.match(/\b(\w)/g).join('')
                this.endDate = data.endDate
                this.address = data.address
                this.emergencyContactName = data.emergencyContactName;
                this.emergencyContactPhone = data.emergencyContactPhone;
                this.tel = `Tel: ${data.tel}`
                this.pOBox = `P.O.Box: ${data.pOBox}`
                this.iDDescription = data.iDDescription
                this.iDDescriptionAmharic = data.iDDescriptionAmharic
                if (data?.idFrontImage) {
                    this.idFrontImage = "data:" +
                        data.idFrontImage.contentType +
                        ";base64," +
                        data.idFrontImage.data
                }
                if (data?.idBackImage) {
                    this.idBackImage = "data:" +
                        data.idBackImage.contentType +
                        ";base64," +
                        data.idBackImage.data
                }
            })
            .catch((e) => {
                console.log(e);
                this.loadingId = false;
            });
    },
    methods: {
        printContent(strid) {
            let prtContent = document.getElementById(strid)
            let content = prtContent.innerHTML
            let winl = (screen.width - 150) / 2
            let wint = (screen.height - 150) / 2
            let WinPrint = window.open('', '', 'letf=' + winl + ',top=' + wint + ',width=400,height=400,font-weight: bold, toolbar=0,scrollbars=0,status=0,resizable=1');
            WinPrint.document.write('<style type="text/css" > @page { size: landscape ;margin: 0cm; font-weight: bold; }  </style> ');
            WinPrint.document.write(content)
            WinPrint.document.close()
            WinPrint.focus()
            WinPrint.print()
            // WinPrint.close()
        }
    },
    computed: {
        backgroundImageInlineStyleFront() {
            return `height: 280px; display: block; background-image:url(${this.idFrontImage})`
        },
        backgroundImageInlineStyleBack() {
            return `height: 280px; display: block; max-height: 280px; background-image:url(${this.idBackImage})`
        }
    }
}
</script>

<style scoped>


</style>
